import React from 'react'
import Rows from './Rows'
import Text from './Text'

export default function Table (props) {
  const textClass = 'data-table__title'

  const RenderRows = (props) => {
    if (props.rows.length > 0) return <Rows rows={props.rows} />
    return null
  }

  return (
    <div className='data-table'>
      <div className='data-table__title-row'>
        <Text text={props.titleLeft} cls={textClass} />
        <Text text={props.titleRight} cls={textClass} />
      </div>
      <RenderRows {...props} />
    </div>
  )
}
